import React from "react";

const ComponentName = () => {
  return (
    <div className="p-4">
        <div>
      <iframe
       className="w-full" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1866.380484642354!2d-103.352532161446!3d20.679301495221!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b1e4f2736863%3A0x5c0da13115763e8!2sCalle%20Contreras%20Medell%C3%ADn%20180%2C%20Zona%20Centro%2C%2044100%20Guadalajara%2C%20Jal.!5e0!3m2!1sen!2smx!4v1736535978201!5m2!1sen!2smx"
        width=""
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
      </div>
    </div>
  );
};

export default ComponentName;
